import { AllocationViewActionIdentifierModel } from '../../models';

export class AllocationViewRegisterNewTruckAction {
  public static readonly type = '[AllocationViewRegisterNewTruckAction] Register New Truck';

  constructor(
    public payload: {
      identifier: AllocationViewActionIdentifierModel;
    },
  ) {}
}

export class AllocationViewRegisterNewTruckSetInitialState {
  public static readonly type = '[AllocationViewRegisterNewTruckAction] Set Initial State';
}
